var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H37C39.7614 0 42 2.23858 42 5V37C42 39.7614 39.7614 42 37 42H5C2.23858 42 0 39.7614 0 37V5Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_9617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4669 16.5423L19.7843 14.2241L19.8018 25.5836C19.8018 26.2739 20.3615 26.8335 21.0518 26.8335C21.7421 26.8335 22.3017 26.2739 22.3017 25.5836L22.2842 14.2382L24.5883 16.5423C25.0679 17.0389 25.8592 17.0526 26.3557 16.573C26.8523 16.0934 26.866 15.3021 26.3864 14.8056C26.3764 14.7952 26.3661 14.7849 26.3557 14.7749L23.6792 12.0983C22.2148 10.6339 19.8405 10.6339 18.3761 12.0983L18.376 12.0983L15.6995 14.7749C15.2199 15.2714 15.2337 16.0627 15.7302 16.5423C16.2146 17.0101 16.9826 17.0101 17.4669 16.5423Z",
    fill: "#2820DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7497 23.0835C29.0594 23.0835 28.4997 23.6431 28.4997 24.3334V28.1591C28.4993 28.3471 28.347 28.4995 28.1589 28.4999H13.8412C13.6531 28.4994 13.5008 28.3471 13.5004 28.1591V24.3334C13.5004 23.6431 12.9408 23.0835 12.2504 23.0835C11.5601 23.0835 11.0005 23.6431 11.0005 24.3334V28.1591C11.0023 29.7272 12.2731 30.998 13.8412 30.9998H28.1589C29.727 30.998 30.9978 29.7272 30.9996 28.1591V24.3334C30.9996 23.6431 30.44 23.0835 29.7497 23.0835Z",
    fill: "#2820DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_9617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUploadIcon);
export default __webpack_public_path__ + "static/media/Image_upload_icon.943fbaadd4f79ef15ef8b04f2b6431d4.svg";
export { ForwardRef as ReactComponent };